import Clerk from '@clerk/clerk-js';

let clerkPromise: Promise<Clerk> | null = null;
let clerkInstance: Clerk | null = null;

function resolvePublishableKey(): string {
  const key =
    import.meta.env.PUBLIC_CLERK_PUBLISHABLE_KEY ??
    import.meta.env.VITE_CLERK_PUBLISHABLE_KEY ??
    import.meta.env.VITE_PUBLIC_CLERK_PUBLISHABLE_KEY;

  if (!key) {
    throw new Error(
      'Missing Clerk publishable key. Set PUBLIC_CLERK_PUBLISHABLE_KEY (or VITE_CLERK_PUBLISHABLE_KEY) in your environment.'
    );
  }

  return key;
}

export function loadClerk(): Promise<Clerk> {
  if (!clerkPromise) {
    clerkPromise = (async () => {
      const publishableKey = resolvePublishableKey();
      const clerk = new Clerk(publishableKey);
      await clerk.load();
      clerkInstance = clerk;
      return clerk;
    })();
  }
  return clerkPromise;
}

export function getClerk(): Clerk {
  if (!clerkInstance) {
    throw new Error('Clerk has not been loaded yet. Call loadClerk() on the client first.');
  }
  return clerkInstance;
}

export async function withClerk<T>(fn: (clerk: Clerk) => T | Promise<T>): Promise<T> {
  const clerk = clerkInstance ?? (await loadClerk());
  return fn(clerk);
}

export function resetClerkForTesting() {
  clerkInstance = null;
  clerkPromise = null;
}
